import React, { useState } from "react";
import { Accordion, Button, Card, Col, Modal, Row } from "react-bootstrap";
import { MdKeyboardArrowRight } from "react-icons/md";

import { formatDDMMYYYYbyYYYYMMDD } from "app/_helpers/helper";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import { FaInfo } from "react-icons/fa";
import { MEETING_STATUS_VIEW, OHSE_ROLE_LIST_VIEW } from "./CONSTANT";

const EventInfo = ({ form, getSchedule }) => {
    const [showModal, setShowModal] = useState(false);
    const previousMeetingObj = getSchedule?.find((d) => d.id === form?.previousMeetingID);
    return (
        <div className="rightIncidentCard mt-4">
            <Accordion defaultActiveKey="0" className="incidentDetailAcc">
                <div>
                    <Accordion.Toggle as={Card.Header} eventKey="0" className="rightInfoTitle">
                        Meeting Info
                        <span style={{ float: "right" }}>
                            <MdKeyboardArrowRight />
                        </span>
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey="0">
                        <Card.Body>
                            <ul style={{ listStyle: "none" }} className="p-0">
                                <li>
                                    <span className="txtgrey">Meeting Id:</span>
                                    <span className="rightData">{form?.scheduleId}</span>
                                </li>
                                <li>
                                    <span className="txtgrey">Meeting Type:</span>
                                    <span className="rightData">{form?.event?.name}</span>
                                </li>
                                <li>
                                    <span className="txtgrey">Meeting Level:</span>
                                    <span className="rightData">{form?.event?.meetingLabel}</span>
                                </li>
                                <li>
                                    <span className="txtgrey">Site Name:</span>
                                    <span className="rightData">{form?.site?.name}</span>
                                </li>
                                <li>
                                    <span className="txtgrey">Venue:</span>
                                    <span className="rightData">{form?.venue}</span>
                                </li>
                                <li>
                                    <span className="txtgrey">Date & Time:</span>
                                    <span className="rightData">{formatDDMMYYYYbyYYYYMMDD(form?.date)}</span>
                                </li>
                                <li>
                                    <span className="txtgrey">Reference Document Description:</span>
                                    <span className="rightData">{form?.refDocumentDescription}</span>
                                </li>
                                <li>
                                    <span className="txtgrey">Remakrs:</span>
                                    <span className="rightData">{form?.remarks}</span>
                                </li>
                                <li>
                                    <span className="txtgrey">Meeting Time Stamp:</span>
                                    <span className="rightData">{formatDDMMYYYYbyYYYYMMDD(form?.actualDate)}</span>
                                </li>
                                <li>
                                    <span className="txtgrey">Previous Meeting Reference:</span>
                                    <span className="rightData">{form?.previousMeetingReference}</span>
                                </li>
                                <li>
                                    <span className="txtgrey">Scheduler:</span>
                                    <span className="rightData">{form?.scheduler ? OHSE_ROLE_LIST_VIEW[form?.scheduler] : OHSE_ROLE_LIST_VIEW[form?.event?.scheduler]}</span>
                                </li>
                                <li>
                                    <span className="txtgrey">Reviewer:</span>
                                    <span className="rightData">{form?.event?.reviewer ? OHSE_ROLE_LIST_VIEW[form?.event?.reviewer] : "Not Applicable"}</span>
                                </li>
                                <li>
                                    <span className="txtgrey">Approver:</span>
                                    <span className="rightData">{form?.approver ? OHSE_ROLE_LIST_VIEW[form?.approver] : OHSE_ROLE_LIST_VIEW[form?.event?.approver]}</span>
                                </li>
                                <li>
                                    <span className="txtgrey">Country:</span>
                                    <span className="rightData">{form?.site?.state?.country_master?.name}</span>
                                </li>
                                <li>
                                    <span className="txtgrey">State:</span>
                                    <span className="rightData">{form?.site?.state?.name}</span>
                                </li>
                                <li>
                                    <span className="txtgrey">Meeting Status:</span>
                                    <span className="rightData">{MEETING_STATUS_VIEW[form?.eventStatus]}</span>
                                </li>
                                <li>
                                    <span className="txtgrey">Previous Meeting ID:</span>
                                    <span className="rightData">{previousMeetingObj?.event?.name} - {previousMeetingObj?.scheduleId}</span>
                                </li>
                                <li>
                                    <span className="txtgrey">Agenda (Brief) <CustomTooltip tooltip="Meeting Agenda (Details)">
                                        <span className="icons font-20 text-cyanBlue" onClick={() => setShowModal(true)}>
                                            <FaInfo />
                                        </span>
                                    </CustomTooltip>:</span>
                                    <span className="rightData">{form?.agenda}</span>
                                </li>
                            </ul>
                        </Card.Body>
                    </Accordion.Collapse>
                </div>
            </Accordion>

            <Modal
                show={showModal}
                onHide={() => {
                    setShowModal(false);
                }}
                backdrop="static"
                size="lg"
            >
                <div className="card" style={{ overflow: "visible" }}>
                    <div className="card-body">
                        <div className="simple-card-title">
                            <h3 className="text-capitalize mb-1">Meeting Agenda (Details)</h3>
                        </div>

                        <Row className="mb-3">
                            <Col lg={12}>
                                <div className="form-group viewbox">
                                    {/* <h5 className="w-500 mb-1">Meeting Agenda (Brief)</h5> */}
                                    <p dangerouslySetInnerHTML={{ __html: form?.detailedAgenda }}></p>
                                    {/* <span className="small text-danger">{errorForm.agenda}</span> */}
                                </div>
                            </Col>
                        </Row>

                        <div className="mt-2 text-center">
                            <Button
                                onClick={() => {
                                    setShowModal(false);
                                }}
                                className="btn btn-secondary mr-2"
                            >
                                Close
                            </Button>
                            {/* 
                <Button onClick={onSubmit} type="submit" variant="primary" className="m-1 text-capitalize">
                  Save
                </Button> */}
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default EventInfo;
